import { render, staticRenderFns } from "./forIncomeReport.vue?vue&type=template&id=72c2ead0&scoped=true&"
import script from "./forIncomeReport.vue?vue&type=script&lang=js&"
export * from "./forIncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./forIncomeReport.vue?vue&type=style&index=0&id=72c2ead0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2ead0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VDatePicker,VIcon,VMenu,VSimpleTable})
